// extracted by mini-css-extract-plugin
export default {"Container":"upload_Container__b8ZIV","img":"upload_img__L5gEZ"};